<template>
<div>
    <div>
        <v-row>
            <v-col align="right" style="padding-right:25px">
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined @click="addTemplateExportSection">Add New Export Section</v-btn>
                <v-btn color="primary" @click="save" style="margin-left:10px">Save</v-btn>
            </v-col>
        </v-row>
    </div>
    <div style="padding-left:15px; padding-right:5px; height:calc(100vh - 165px); max-height:calc(100vh - 165px); overflow: hidden scroll; margin-top:10px">
        <v-expansion-panels multiple accordion>
            <v-expansion-panel
            v-for="(group, idx) in groupedSections"
            :key="idx"
            >
            <v-expansion-panel-header style="padding-left:10px">{{group.section}}</v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row dense>
                <v-col cols="3">Section Name:</v-col>
                <v-col cols="3">
                    <v-text-field dense v-model="group.default.section" @input="syncSectionName(group)"></v-text-field>
                </v-col>
                <v-col cols="3"></v-col>
                <v-col cols="3" align="left">
                    <v-switch
                    v-model="group.default.is_active"
                    label="Active?"
                    ></v-switch>
                </v-col>
                </v-row>

                <v-tabs :value="activeTabs[idx] || 0" @change="$set(activeTabs, idx, $event)" class="mb-3">
                    <v-tab>{{ group.default.country_label || 'Default' }}</v-tab>
                    <v-tab v-for="(country, cIdx) in group.countries" :key="cIdx">
                        {{ country.country_label || 'New Country' }}
                    </v-tab>
                    <v-btn icon small class="align-self-center ml-2" @click="addCountryOverride(group, idx)">
                        <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                </v-tabs>

                <v-tabs-items :value="activeTabs[idx] || 0" @change="$set(activeTabs, idx, $event)">
                    <!-- Default tab -->
                    <v-tab-item>
                        <v-row dense align="center" class="mt-2 mb-2">
                            <v-col cols="3">
                                <v-text-field dense v-model="group.default.country_label" label="Country Label" placeholder="Default" outlined hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                        <v-col cols="6">
                            Internal Content: <br/>
                            <v-textarea
                            rows="10"
                            outlined
                            auto-grow
                            v-model="group.default.section_content_internal"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="6">
                            External Content: <br/>
                            <v-textarea
                            rows="10"
                            outlined
                            auto-grow
                            v-model="group.default.section_content_external"
                            ></v-textarea>
                        </v-col>
                        </v-row>
                    </v-tab-item>

                    <!-- Country override tabs -->
                    <v-tab-item v-for="(country, cIdx) in group.countries" :key="cIdx">
                        <v-row dense align="center" class="mt-2 mb-2">
                            <v-col cols="3">
                                <v-text-field dense v-model="country.country_label" label="Country Label" outlined hide-details></v-text-field>
                            </v-col>
                            <v-col cols="6"></v-col>
                            <v-col cols="3" align="right">
                                <v-switch
                                v-model="country.is_active"
                                label="Active?"
                                hide-details
                                class="mt-0"
                                ></v-switch>
                            </v-col>
                        </v-row>
                        <v-row dense>
                        <v-col cols="6">
                            Internal Content: <br/>
                            <v-textarea
                            rows="10"
                            outlined
                            auto-grow
                            v-model="country.section_content_internal"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="6">
                            External Content: <br/>
                            <v-textarea
                            rows="10"
                            outlined
                            auto-grow
                            v-model="country.section_content_external"
                            ></v-textarea>
                        </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs-items>
            </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>

    <Loading :isVisible="isLoading" />
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
</div>

</template>


<script>
import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler";

export default {
  name: "templateExportSections",
  components: {
    ResponseHandler
  },
  props: {
    value: { type: Number, required: false },
  },
  data: function () {
    return {
      isLoading: false,
      response: null,
      exportSections: [],
      activeTabs: {}
    };
  },
  mounted() {},
  created() {
    this.init();
  },
  watch: {
    value() {
      this.init();
    },
  },
  computed: {
    groupedSections() {
      const groups = [];
      const groupMap = {};
      this.exportSections.forEach(s => {
        if (s.is_default) {
          const group = { section: s.section, default: s, countries: [] };
          groupMap[s.section] = group;
          groups.push(group);
        }
      });
      this.exportSections.forEach(s => {
        if (!s.is_default && groupMap[s.section]) {
          groupMap[s.section].countries.push(s);
        }
      });
      return groups;
    }
  },
  methods: {
    addTemplateExportSection(){
      this.exportSections.push({
        section: "New Section",
        country_label: null,
        is_default: 1,
        section_content_internal: "",
        section_content_external: "",
        is_active: true,
        tmpl_export_section_id: 0
      });
    },
    addCountryOverride(group, idx) {
      this.exportSections.push({
        section: group.default.section,
        country_label: "",
        is_default: 0,
        section_content_internal: "",
        section_content_external: "",
        is_active: true,
        tmpl_export_section_id: 0
      });
      this.$nextTick(() => {
        this.$set(this.activeTabs, idx, group.countries.length);
      });
    },
    syncSectionName(group) {
      const newName = group.default.section;
      group.countries.forEach(c => { c.section = newName; });
    },
    sessionExpired(err) {
      this.$emit("sessionExpired", err);
    },
    save(){
        const sections = this.exportSections.filter(s => {
            if (!s.is_default) {
                const hasData = (s.country_label || '').trim() || (s.section_content_internal || '').trim() || (s.section_content_external || '').trim();
                return !!hasData;
            }
            return true;
        });
        let data = {
            tmpl_id: this.value,
            sections: sections
        }

        let possibleError = false;
        this.isLoading = true;

        axios
        .post("templateBuilder/saveTemplateExportSections", data)
        .then((resp) => {
          possibleError = true;
          this.exportSections = resp.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
    init() {
      let possibleError = false;
      this.isLoading = true;
      axios
        .get("templateBuilder/templateExportSections/" + this.value)
        .then((resp) => {
          possibleError = true;
          this.exportSections = resp.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
  },
};
</script>
